import { catchError, EMPTY, finalize, tap } from 'rxjs';
import { TableDataSource } from '@shared';
import { IntRegistersApiService } from '../../../../../../services/int-registers-api/int-registers-api.service';
import { InternationalInvoice } from '../../../../../../models/international-invoice';
import { AlertToastService } from '@services';

export class IntRegistersShowDataSource extends TableDataSource<InternationalInvoice> {
  constructor(
    protected intRegistersApi: IntRegistersApiService,
    protected alertToastService: AlertToastService,
  ) {
    super();
  }

  loadInvoices(registerRef: string, page: number, limit: number): void {
    this.loading.next(true);
    this.intRegistersApi.getInvoices(registerRef, page, limit)
      .pipe(
        finalize(() => this.loading.next(false)),
        tap(res => {
          this.source.next(res?.list || []);
          this.total.next(res?.total || 0);
        }),
        catchError(errors => {
          if (errors[0]) {
            this.alertToastService.pushApiErrors(errors);
          }
          this.source.next([]);
          this.total.next(0);

          return EMPTY;
        }),
      ).subscribe();
  }
}
